import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  icon?: string;
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;
  readonly toasts = signal<Toast[]>([]);

  private iconMap: Record<string, string> = {
    success: 'check_circle',
    error: 'error',
    warning: 'warning',
    info: 'info',
  };

  show(type: Toast['type'], message: string, icon?: string, duration = 4000) {
    const toast: Toast = {
      id: this.nextId++,
      type,
      message,
      icon: icon || this.iconMap[type],
      duration,
    };
    this.toasts.update(list => [...list, toast]);

    if (duration > 0) {
      setTimeout(() => this.dismiss(toast.id), duration);
    }
  }

  success(message: string, icon?: string) { this.show('success', message, icon); }
  error(message: string, icon?: string) { this.show('error', message, icon, 6000); }
  warning(message: string, icon?: string) { this.show('warning', message, icon, 5000); }
  info(message: string, icon?: string) { this.show('info', message, icon); }

  dismiss(id: number) {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }
}
